import React from "react";
import { Link } from "react-router-dom";

export default function Error() {
    return (
        <>
            <div className="error-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="error-imagebox-inner">
                                <div className="error-imagebox">
                                    <img src="/assets/images/error-img.webp" alt="404" className="img-responsive" />
                                </div>
                                <div className="error-content">
                                    <h1 className="heading">Oops! You’ve Hit a Dead End</h1>
                                    <p>This page isn’t available right now. Oops! Hit a Dead End? Find your way back to Catalyze & explore experiences that turn potential into meaningful progress.</p>
                                    <div className="error-btns">
                                        <div className="error-btn1">
                                            <Link className="default-btn" to={"/"}>
                                                Back To Homepage
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}